import { acceptHMRUpdate, defineStore } from 'pinia'

import { type TransactionMonitoringRiskConfig } from '~/types.ts'

export const useTransactionMonitoringRiskConfig = defineStore('transactionMonitoringRiskConfig', () => {
  const config = ref<TransactionMonitoringRiskConfig>()
  const loading = ref(false)

  async function load() {
    if (loading.value || config.value?.id) return
    loading.value = true

    try {
      const { data } = await api.get<TransactionMonitoringRiskConfig>(`transaction-monitoring-risk-configs/${stores.organization.id}`)
      config.value = data
    } finally {
      loading.value = false
    }
  }

  async function save(form: Partial<TransactionMonitoringRiskConfig> = {}) {
    loading.value = true

    try {
      if (config.value?.id) {
        const { data } = await api.patch(`transaction-monitoring-risk-configs/${config.value?.id}`, form)
        config.value = data
      } else {
        const { data } = await api.post('transaction-monitoring-risk-configs', { ...config.value, ...form })
        config.value = data
      }
    } finally {
      loading.value = false
    }
  }

  return {
    config,
    loading,
    load,
    save,
  }
})

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useTransactionMonitoringRiskConfig, import.meta.hot))
}
